module.exports = __webpack_public_path__ + "static/media/seta-bt.46a5f1be.svg";